import type { RootState } from '@/store/root-reducer';

const selectMyProfilesState = (state: RootState) => state.myProfiles;

export const selectRows = (state: RootState) => selectMyProfilesState(state).rows;
export const selectTotal = (state: RootState) => selectMyProfilesState(state).total;
export const selectLoading = (state: RootState) => selectMyProfilesState(state).loading;
export const selectError = (state: RootState) => selectMyProfilesState(state).error;
export const selectPage = (state: RootState) => selectMyProfilesState(state).page;
export const selectPageSize = (state: RootState) => selectMyProfilesState(state).pageSize;
export const selectFilters = (state: RootState) => selectMyProfilesState(state).filters;
export const selectSearch = (state: RootState) => selectMyProfilesState(state).search;
export const selectSort = (state: RootState) => selectMyProfilesState(state).sort;
export const selectAiSearch = (state: RootState) => selectMyProfilesState(state).aiSearch;

/** The category band's figures, or null until they land (#553). */
export const selectCategoryCounts = (state: RootState) =>
  selectMyProfilesState(state).categoryCounts;

/** The licence the list is held to, or null until the page sets it (PI-117). */
export const selectLicenceId = (state: RootState) => selectMyProfilesState(state).licenceId;

/** The Country and Custom tags facets' choices (#615). */
export const selectFacetOptions = (state: RootState) => selectMyProfilesState(state).facetOptions;
